import { clsx } from 'clsx';
import * as styles from './styles.css';
import { ReactNode } from 'react';
import { Button, useDeviceType } from '@cian/ui-kit';
import { useLocalStorage } from 'shared/hooks';
import { TDoor } from 'shared/types/doors';

interface IDoorContentProps extends TDoor {
  children: ReactNode;
  btnText: string;
  secondBtn?: {
    btnText: string;
    onSecondBtn: VoidFunction;
  };
  firstBtnClicked?: boolean;
  isLoading: boolean;
}

const getStorageKey = (doorId?: number, title?: string): string => {
  if (doorId) {
    return `door-first-button-clicked-${doorId}`;
  }

  return `door-first-button-clicked-${title || 'default'}`;
};

export const DoorContent: React.FC<IDoorContentProps> = ({
  title,
  image,
  children,
  btnText,
  secondBtn,
  onClickBtn,
  firstBtnClicked = false,
  doorId,
  isLoading,
}) => {
  const device = useDeviceType();
  const storageKey = getStorageKey(doorId, title);
  const [isFirstButtonClicked, setIsFirstButtonClicked] = useLocalStorage(storageKey, firstBtnClicked);

  const handleFirstButtonClick = () => {
    onClickBtn();
    setIsFirstButtonClicked(true);
  };

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['title-container']}>
        <div className={clsx(styles['image'], styles[image])} />
        <div className={styles['title']}>{title}</div>
      </div>
      <div className={styles['content-container']}>
        {children}
        <div className={styles['btn']}>
          <Button onClick={handleFirstButtonClick} loading={secondBtn ? undefined : isLoading} fullWidth>
            {btnText}
          </Button>
        </div>
        {secondBtn && (
          <div className={styles['btn']}>
            <Button onClick={secondBtn.onSecondBtn} loading={isLoading} disabled={!isFirstButtonClicked} fullWidth>
              {secondBtn.btnText}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
